import { EyeStroke, FileMultipleStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { TEMPLATE_BASE64 as excelTemplate_danh_muc_khai_bao_kho_vat_tu_quy_doi_don_vi_tinh_chi_tiet_DMQDDVT } from '@/lib/templates-base64/DMQDDVT';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { downloadBase64Excel } from '@/lib/template-downloader';
import { useQuyDoiDonViTinhChiTietContext } from '../context';

interface ActionBarProps {
  onAddIconClick: () => void;
  onEditIconClick: () => void;
  onDeleteIconClick: () => void;
  onCopyIconClick: () => void;
  onWatchIconClick: () => void;
  onRefreshClick?: () => void;
  onImportExcel?: () => void;
  hasRowSelected?: boolean;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onAddIconClick,
  onEditIconClick,
  onDeleteIconClick,
  onCopyIconClick,
  onWatchIconClick,
  onRefreshClick,
  onImportExcel,
  hasRowSelected = false
}) => {
  const { exportToExcel, canExport, isExporting } = useQuyDoiDonViTinhChiTietContext();
  const handleDownloadTemplate = () => {
    downloadBase64Excel(
      excelTemplate_danh_muc_khai_bao_kho_vat_tu_quy_doi_don_vi_tinh_chi_tiet_DMQDDVT,
      'Danh mục quy đổi đơn vị tính.xlsx'
    );
  };

  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục quy đổi đơn vị tính</h1>}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddIconClick} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditIconClick} disabled={!hasRowSelected} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteIconClick} disabled={!hasRowSelected} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyIconClick} disabled={!hasRowSelected} />
      <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onWatchIconClick} disabled={!hasRowSelected} />

      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 0
          },
          {
            title: isExporting ? 'Đang kết xuất...' : 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={18} />,
            onClick: exportToExcel,
            disabled: !canExport || isExporting,
            loading: isExporting,
            loadingTitle: 'Đang kết xuất...',
            group: 1
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadTemplate,
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportExcel,
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
